/**
 * @generated SignedSource<<965931c6e099c0714feedf11864caf9d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoEditDeadlinePopover_todo$data = {
  readonly expireAt: string | null;
  readonly id: string;
  readonly " $fragmentType": "TodoEditDeadlinePopover_todo";
};
export type TodoEditDeadlinePopover_todo$key = {
  readonly " $data"?: TodoEditDeadlinePopover_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditDeadlinePopover_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoEditDeadlinePopover_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expireAt",
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "1bbfd0adb15a992229d025aaa7d5757a";

export default node;
